import {colors} from "@c10h/colors";
import NextImage from "@components/NextImage";
import {Testimonial} from "@components/TestimonialSlider";
import React from "react";
import {BtnProps} from "src/components/v5/V5Comp";

import {ImageExtension} from "../utils/nextImageSource";
import {useTranslation} from "@i18n/client";

type BenefitsProps = {
  src: string;
  header: string;
  backgroundColor: string;
  pattern: string;
  body?: string | null;
  imgExtension?: ImageExtension;
}[];
type PartnersConstants = {
  benefits: BenefitsProps;
  ctaProps: BtnProps;
  testimonials: Testimonial[];
};

export const usePartnersConstants = (): PartnersConstants => {
  const {t} = useTranslation();
  const benefits: BenefitsProps = [
    {
      src: "/illustrations/doctor-and-patient-mask",
      header: t("Coordinated care delivery"),
      body: t(
        "We partner with hospitals, specialists, and medical groups to coordinate care delivery in local markets and better serve communities.",
      ),
      backgroundColor: colors.lightGreen,
      pattern: "0",
      imgExtension: "png",
    },

    {
      src: "/illustrations/doctor-and-patient",
      header: t("Comprehensive first-line care"),
      body: t(
        "Together, we increase access points for first-line care including primary care, urgent care, and/or behavioral health capacity.",
      ),
      backgroundColor: colors.lightPurple,
      pattern: "4",
    },
    {
      src: "/illustrations/happy-healthy-person-smiling",
      header: t("Streamline access"),
      body: t(
        "We seamlessly coordinate care so patients and clinicians can focus on what’s truly important.",
      ),
      backgroundColor: colors.lightBlue,
      pattern: "2",
    },
  ];

  const ctaProps = {
    "aria-label": t("Click to scroll to the contact form."),
    href: "#get-started",
    children: t("Talk to Our Team"),
    fontSize: 1.25,
    className: "focus-bsDarkBlue3 bold",
  };

  const testimonials: Testimonial[] = [
    {
      body: t(
        "Carbon Health’s fresh approach to healthcare has further established our reach and visibility as a leading provider in our region. Since our partnership, we expanded market reach and converted over 10% of new patients to our medical group.",
      ),
      bg: colors.darkerMint,
      color: "#fff",
      who: {
        name: "Aimee Brewer",
        who: t("President, Northbay Healthcare Group"),
      },
      headImg: (
        <NextImage
          src="/partners/northbay-logo-white"
          alt="Northbay Healthcare"
          width={150}
          height={38}
          extension="svg"
        />
      ),
      hideHeadTitle: true,
    },
  ];

  return {benefits, ctaProps, testimonials};
};
